
document.addEventListener('countdown:started', (event) => {
	const now = new Date();

	const nowInCET = new Date(
    now.toLocaleString('en-US', { timeZone: 'Europe/Berlin' })
  );

  const year = nowInCET.getFullYear();
  const month = nowInCET.getMonth(); 
	const day = nowInCET.getDate();

    const collectionWrapper = document.querySelector('[black-deal-collection]');
    if (collectionWrapper) {
			if (year === 2025 && (month === 10 || month === 9 || (month === 11 && day === 1))) {
        collectionWrapper.classList.add('black-deal--countdown');
			}
    }
});


document.addEventListener('countdown:ended', () => {
	const collectionWrapper = document.querySelector('[black-deal-collection]');
		if (collectionWrapper) {	
			collectionWrapper.classList.remove('black-deal--countdown');
		}
});

document.addEventListener("DOMContentLoaded", function() {
	const now = new Date();

	const nowInCET = new Date(
    now.toLocaleString('en-US', { timeZone: 'Europe/Berlin' })
  );

  const year = nowInCET.getFullYear();
  const month = nowInCET.getMonth(); 
	const day = nowInCET.getDate();

	// const day = nowInCET.getDate();
	const elements = document.querySelectorAll('[black-deal-top], [black-deal-pdp]');

	if (elements.length > 0) {
		elements.forEach(el => {
			if (el) {
				if (year === 2025 && (month === 10 || month === 9 ||
        (month === 11 && day === 1))) {
					el.classList.add('black-deal--countdown');
				} else {
					el.classList.remove('black-deal--countdown');	
				}
			}
		});
	}
});